<template>

  <div class="page text_center">
    <div class="header">
      <h1>魔法英语背单词</h1>
      <div class="flex space_around ">
        <h3> 背诵词库：初中英语单词(上海版)</h3>
        <h3>Name: Tom | 学习记录 | 课程安排</h3>
      </div>
    </div>

    <button v-show="state.finsh" class="btn btn_ok" @click="agin">重新开始</button>

    <div class="word-container" v-if="state.currentWord&&!state.finsh">
      <p class="text_right" @click="handle"><img v-if="!state.audioShow" src="../assets/images/laba1.png" alt=""><img
          v-if="state.audioShow" src="../assets/images/laba2.png" alt="">
      </p>
      <span :class="['word', state.wordClasses]">
        {{state.currentWord.word}}
      </span>

      <div v-if="state.showTranslation" :class="['translation', state.translationClasses]">
        {{state.currentWord.translation}}
      </div>
    </div>



    <div class="button" v-if="!state.finsh">
      <button v-if="!state.showQuestionClicked" class="btn btn_question" @click="showTranslationFunc">不熟悉</button>
      <button v-if="state.showQuestionClicked" class="btn btn_question" @click="showTranslationAndNext">>></button>

      <button v-if="!state.showQuestionClicked" class="btn btn_ok" @click="showTranslationAndNext">认识的</button>
      <button v-if="state.showQuestionClicked" class="btn btn_ok" @click="nextWordAfterTranslation">>></button>
    </div>

  </div>

  <audio ref="audio"></audio>

</template>

<script setup>
  import { ref, reactive, toRefs, onMounted } from "vue";
  import { ElMessage } from "element-plus";
  import 'animate.css';
  import axios from 'axios'
  const audio = ref()
  const state = reactive({
    words: [
      { word: 'adhere', translation: 'v. 附着，追随，坚持' },
      { word: 'badge', translation: 'n. 徽章，奖章' },
      { word: 'energetic', translation: 'a. 精力充沛的' },
      { word: 'primitive', translation: 'a. 原始的，早期的' },
      { word: 'convey', translation: 'v. 表达，传达' },
      { word: 'duplicate', translation: ' v. 复制，重复' },
      { word: 'Acquire', translation: 'v. 获取，学到' },
      { word: 'Beneficial', translation: 'adj. 有益的，有利的' },
      { word: 'Conscientious', translation: ' adj. 认真的，尽责的' },
      { word: 'Disparity', translation: 'n. 不同，差异' },
      { word: 'Eminent', translation: 'adj. 杰出的，显著的' },
      { word: 'Fortuitous', translation: 'adj. 偶然的，意外的' },
      { word: 'Hierarchy', translation: 'n. 等级制度，层次' },
      { word: 'Innovative', translation: 'adj. 创新的，革新的' },
      { word: 'Jargon', translation: 'n. 行话，术语' },
      { word: 'Kiosk', translation: 'n. 售货亭，报刊亭' },
    ],
    currentWord: null,
    showTranslation: false,
    wordClasses: '',
    translationClasses: '',
    showQuestionClicked: false,
    finsh: false,
    audioShow: false
  });
  onMounted(() => {
    nextWord();
  });

  const agin = () => {
    state.words = [
      { word: 'adhere', translation: 'v. 附着，追随，坚持' },
      { word: 'badge', translation: 'n. 徽章，奖章' },
      { word: 'energetic', translation: 'a. 精力充沛的' },
      { word: 'primitive', translation: 'a. 原始的，早期的' },
      { word: 'convey', translation: 'v. 表达，传达' },
      { word: 'duplicate', translation: ' v. 复制，重复' },
      { word: 'Acquire', translation: 'v. 获取，学到' },
      { word: 'Beneficial', translation: 'adj. 有益的，有利的' },
      { word: 'Conscientious', translation: ' adj. 认真的，尽责的' },
      { word: 'Disparity', translation: 'n. 不同，差异' },
      { word: 'Eminent', translation: 'adj. 杰出的，显著的' },
      { word: 'Fortuitous', translation: 'adj. 偶然的，意外的' },
      { word: 'Hierarchy', translation: 'n. 等级制度，层次' },
      { word: 'Innovative', translation: 'adj. 创新的，革新的' },
      { word: 'Jargon', translation: 'n. 行话，术语' },
      { word: 'Kiosk', translation: 'n. 售货亭，报刊亭' },
    ]
    state.finsh = false
    nextWord()
  }

  const nextWord = () => {
    if (state.words.length === 0) {
      state.finsh = true
      return;
    }
    if (state.words.length > 0) {
      state.currentWord = state.words.shift();
      state.showTranslation = false;
      state.wordClasses = 'a-text';
      state.translationClasses = '';
      state.showQuestionClicked = false;
      if (state.audioShow) {
        textToSpeech()
      }
    }
  };

  const showTranslationFunc = () => {
    state.showTranslation = true;
    state.showQuestionClicked = true;
  };

  const showTranslationAndNext = () => {
    state.showTranslation = true;
    state.wordClasses = 'erasing-text';
    state.translationClasses = 'erasing-text';

    setTimeout(() => {
      nextWord();
    }, 1200);
  };

  const nextWordAfterTranslation = () => {
    state.wordClasses = 'erasing-text';
    state.translationClasses = 'erasing-text';
    setTimeout(() => {
      state.showTranslation = false;
      nextWord();
    }, 1200);
  };

  const handle = () => {
    state.audioShow = !state.audioShow
  };
  const textToSpeech = async () => {
    const language = 'zh-CN';
    const voice = 'zh-CN-XiaochenMultilingualNeural';
    const text = state.currentWord.word;
    const azureKey = "1d7bcbed7ed240e7b4009a6876462ff1";
    const azureEndpoint = `https://japaneast.tts.speech.microsoft.com/cognitiveservices/v1`;
    const speed = "0%";

    try {
      const response = await axios({
        url: azureEndpoint,
        method: 'POST',
        headers: {
          'Content-Type': 'application/ssml+xml',
          'X-Microsoft-OutputFormat': 'audio-16khz-32kbitrate-mono-mp3',
          'Ocp-Apim-Subscription-Key': azureKey,
        },
        responseType: 'arraybuffer',
        data: `
      <speak version="1.0" xml:lang="${language}">
      <voice name="${voice}">
        <prosody rate="${speed}">${text}</prosody>
      </voice>
      </speak>`,
      });

      if (response.status === 200) {
        const blob = new Blob([response.data], { type: 'audio/mp3' });
        const url = URL.createObjectURL(blob);
        audio.value.src = url;
        audio.value.play();
        audio.value.addEventListener('ended', () => {
          // state.is_audio = false;
        });
      }
    } catch (error) {
      console.log('az_error', error);
    }
  }
</script>

<style lang="less" scoped>
  .page {
    text-align: center;
    background-color: #efefef;
    min-height: 100vh;

    h1 {
      margin-top: 0;
    }

    img {
      width: 50px;
    }
  }

  .header {
    height: 16vh;
    padding-top: 20px;
    box-sizing: border-box;
  }


  .word {
    font-size: 150px;
    margin: 30px 0 15px 0;
    color: #2e54a1;
    display: inline-block;
  }

  .translation {
    font-size: 60px;
  }

  .btn {
    color: #fff;
    font-size: 34px;
    width: 200px;
    padding: 10px 20px;
    margin: 50px 100px;
    border-radius: 35px;
    border: none;
    box-sizing: border-box;


  }

  .button {
    box-sizing: border-box;

  }

  .btn_question {
    background-color: #ee822f;
  }

  .btn_ok {
    background-color: #30c0b4;
  }

  .btn_arrow {
    background-color: #91ace0;
  }

  .audio_img {
    cursor: pointer;
  }





  .erasing-text {
    position: relative;
    overflow: hidden;
  }

  .erasing-text::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 0;
    background-color: #fff;
    animation: eraseText 0.6s linear forwards;
  }

  @keyframes eraseText {
    to {
      width: 100%;
    }
  }


  .a-text {
    white-space: nowrap;
    overflow: hidden;
    position: relative;
    display: inline-block;
  }

  .a-text::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    animation: eraseTexta 1.5s forwards;
  }

  @keyframes eraseTexta {
    from {
      right: 0%;
    }

    to {
      right: -100%;
    }
  }

  .word-container {
    height: 55vh;
    background-color: #fff;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    padding: 20px;
    box-sizing: border-box;
  }
</style>